<section class="common__spacing--between-section">
  <div class="container-fluid">
    <div class="feature-section_heading text-align-center">
      <h2 class="secondary__heading">Oops!</h2>
    </div>
  </div>
</section>
<div class="notFoundPage">
  <div class="container-fluid">
    <article>
      <p>Oops! Seems you've reached a page that does not exist</p>
    </article>
  </div>
</div>
